import { css } from '@emotion/css';

export const itemSize = (size: number) => css`
  width: ${size}px;
  height: ${size}px;
`;
